export default __webpack_public_path__ + "static/media/111.88cb99f6.png";